import { create } from 'domain'
import { apiBaseUrl } from '../const'
import { removeAgent, updateAgent } from '../data/pages/agents'
import { list } from 'postcss'

export default {
  // App
  root: () => `${apiBaseUrl}/`,

  // Admins
  createAdmin: () => `${apiBaseUrl}/admins`,
  listAdmins: () => `${apiBaseUrl}/admins/all`,
  listAgents: () => `${apiBaseUrl}/agents/all`,
  adminById: (id: string) => `${apiBaseUrl}/admins/${id}`,
  user: (id: string) => `${apiBaseUrl}/admins/${id}`,
  adminLogin: () => `${apiBaseUrl}/admins/login`,
  getAuth: () => `${apiBaseUrl}/admins/authenticate`,
  listAgentsWithVips: () => `${apiBaseUrl}/admins/agents-with-vips`,
  avatars: () => `${apiBaseUrl}/files/upload`,
  updateAdmin: () => `${apiBaseUrl}/admins/update`,

  // Agents
  agentHierarchy: () => `${apiBaseUrl}/agents/hierarchy`,
  resetSteal: () => `${apiBaseUrl}/agents/reset-steal-status`,
  agentList: () => `${apiBaseUrl}/agents/by-parent-id`,
  updateAgent: (id: string) => `${apiBaseUrl}/agents/${id}/update`,
  removeAgent: (id: string) => `${apiBaseUrl}/agents/${id}/remove`,
  agentDetails: (id: string) => `${apiBaseUrl}/agents/${id}`,
  allAgents: () => `${apiBaseUrl}/agents/all`,
  createAgent: () => `${apiBaseUrl}/agents`,

  // Versions
  createVersion: () => `${apiBaseUrl}/versions/create`,
  listVersions: () => `${apiBaseUrl}/versions/all`,
  updateVersion: (id: number) => `${apiBaseUrl}/versions/${id}/update`,
  deleteVersion: (id: number) => `${apiBaseUrl}/versions/${id}/delete`,

  // Versions Link
  createVersionLink: () => `${apiBaseUrl}/version-links`,
  listVersionLinks: () => `${apiBaseUrl}/version-links/all`,
  updateVersionLink: (id: number) => `${apiBaseUrl}/version-links/${id}/update`,
  deleteVersionLink: (id: number) => `${apiBaseUrl}/version-links/${id}/delete`,

  // Videos
  createVideo: () => `${apiBaseUrl}/videos/create`,
  listVideos: () => `${apiBaseUrl}/videos/all`,
  getVideo: (id: string | number) => `${apiBaseUrl}/videos/${id}`,
  updateVideo: (id: string | number) => `${apiBaseUrl}/videos/${id}/update`,
  deleteVideo: (id: string | number) => `${apiBaseUrl}/videos/${id}/delete`,
  playVideo: () => `${apiBaseUrl}/videos/playvideo`,
  playphoto: () => `${apiBaseUrl}/videos/playphoto`,
  // updateVideoPrices: () => `${apiBaseUrl}/videos/update-bulk`,

  // Category
  listCategories: () => `${apiBaseUrl}/categories/all`,
  createCategory: () => `${apiBaseUrl}/categories/create`,
  getCategory: (id: number) => `${apiBaseUrl}/categories/${id}`,
  updateCategory: (id: number) => `${apiBaseUrl}/categories/${id}/update`,
  deleteCategory: (id: number) => `${apiBaseUrl}/categories/${id}/delete`,

  // Announcement
  listAnnouncements: () => `${apiBaseUrl}/admin/announcements/stats`,
  createAnnouncement: () => `${apiBaseUrl}/admin/announcements`,
  getAnnouncement: (id: number) => `${apiBaseUrl}/admin/announcements/${id}`,
  updateAnnouncement: (id: number) => `${apiBaseUrl}/admin/announcements/${id}/update`,
  deleteAnnouncement: (id: number) => `${apiBaseUrl}/admin/announcements/${id}/delete`,
  toggleAnnouncement: (id: number) => `${apiBaseUrl}/admin/announcements/${id}/toggle`,
  /** GET — encrypted raw URLs JSON string for client bundle (export as api.json) */
  urlsJsonEncryptedRaw: () => `${apiBaseUrl}/admin/urls-json/encrypted-raw`,

  // FPost
  listPosts: () => `${apiBaseUrl}/f-post/all`,
  createPost: () => `${apiBaseUrl}/f-post/create`,
  updatePost: (id: number) => `${apiBaseUrl}/f-post/${id}/update`,
  deletePost: (id: number) => `${apiBaseUrl}/f-post/${id}/delete`,
  // updatePostPrices: () => `${apiBaseUrl}/f-post/update-bulk`,

  // Steal History
  getStealHistoryStats: () => `${apiBaseUrl}/steal-history/statistics`,
  getAllStealHistory: () => `${apiBaseUrl}/steal-history/all`,
  getStealHistoryById :(id: number) => `${apiBaseUrl}/steal-history/${id}`,
  //FCategoryPost
  listCategoryPosts: () => `${apiBaseUrl}/f-category/all`,
  createCategoryPost: () => `${apiBaseUrl}/f-category/create`,
  getCatgoryPost: (id: number) => `${apiBaseUrl}/f-category/${id}`,
  updateCategoryPost: (id: number) => `${apiBaseUrl}/f-category/${id}/update`,
  deleteCategoryPost: (id: number) => `${apiBaseUrl}/f-category/${id}/delete`,

  //Tag
  listTags: () => `${apiBaseUrl}/v-tag/all`,
  createTag: () => `${apiBaseUrl}/v-tag/create`,
  updateTag: (id: number) => `${apiBaseUrl}/v-tag/${id}/update`,
  deleteTag: (id: number) => `${apiBaseUrl}/v-tag/${id}/delete`,

  // TagPost
  listTagPosts: () => `${apiBaseUrl}/f-tag/all`,
  createTagPost: () => `${apiBaseUrl}/f-tag/create`,
  getTagPost: (id: number) => `${apiBaseUrl}/f-tag/${id}`,
  updateTagPost: (id: number) => `${apiBaseUrl}/f-tag/${id}/update`,
  deleteTagPost: (id: number) => `${apiBaseUrl}/f-tag/${id}/delete`,

  //Banner
  createBanner: () => `${apiBaseUrl}/banniere/create`,
  listBanners: () => `${apiBaseUrl}/banniere/all`,
  getBanner: (id: number) => `${apiBaseUrl}/banniere/${id}`,
  updateBanner: (id: number) => `${apiBaseUrl}/banniere/${id}/update`,
  deleteBanner: (id: number) => `${apiBaseUrl}/banniere/${id}/delete`,

  // Gestion Traduction
  createTranslate: () => `${apiBaseUrl}/i18n/translationData/create`,
  getTranslateByCountry: () => `${apiBaseUrl}/i18n/translationData/getByCountry`,
  updateTranslate: () => `${apiBaseUrl}/i18n/translationData/update`,
  deleteTranslate: () => `${apiBaseUrl}/i18n/translationData/delete`,
  translationData: () => `${apiBaseUrl}/i18n/translationData/import-flat`,

  //Emoji
  createEmoji: () => `${apiBaseUrl}/emoji/create`,
  createMoreEmoji: () => `${apiBaseUrl}/emoji/create-more`,
  listEmoji: () => `${apiBaseUrl}/emoji/all`,
  getEmoji: (id: number) => `${apiBaseUrl}/emoji/${id}`,
  updateEmoji: (id: number) => `${apiBaseUrl}/emoji/${id}/update`,
  deleteEmoji: (id: number) => `${apiBaseUrl}/emoji/${id}/delete`,

  // Emoji group
  createEmojigroup: () => `${apiBaseUrl}/emoji-group/create`,
  listEmojigroup: () => `${apiBaseUrl}/emoji-group/all`,
  getEmojigroup: (id: number) => `${apiBaseUrl}/emoji-group/${id}`,
  updateEmojigroup: (id: number) => `${apiBaseUrl}/emoji-group/${id}/update`,
  deleteEmojigroup: (id: number) => `${apiBaseUrl}/emoji-group/${id}/delete`,

  // Domains
  listDomains: () => `${apiBaseUrl}/admin/domains/list`,
  deleteDomain: () => `${apiBaseUrl}/admin/domains/delete`,
  updateDomain: () => `${apiBaseUrl}/admin/domains/update`,
  createDomain: () => `${apiBaseUrl}/admin/domains/create`,
  getLandingPages: () => `${apiBaseUrl}/admin/domains/landing-pages`,

  // Domain Short
  listDomainShorts: () => `${apiBaseUrl}/domain-short/all`,
  createDomainShort: () => `${apiBaseUrl}/domain-short/create`,
  getDomainShort: (id: string) => `${apiBaseUrl}/domain-short/${id}`,
  updateDomainShort: (id: string) => `${apiBaseUrl}/domain-short/${id}/update`,
  deleteDomainShort: (id: string) => `${apiBaseUrl}/domain-short/delete/${id}`,
  updateDomainShortStatus: (id: number) => `${apiBaseUrl}/domain-short/update-status/${id}`,

  // Domain Short Type
  listDomainShortTypes: () => `${apiBaseUrl}/domain-short-type/all`,
  createDomainShortType: () => `${apiBaseUrl}/domain-short-type/create`,
  getDomainShortType: (id: string) => `${apiBaseUrl}/domain-short-type/${id}`,
  updateDomainShortType: (id: string) => `${apiBaseUrl}/domain-short-type/update/${id}`,
  deleteDomainShortType: (id: string) => `${apiBaseUrl}/domain-short-type/delete/${id}`,
 
  // Dasboard
  getVisits: () => `${apiBaseUrl}/tracking`,
  getTime: () => `${apiBaseUrl}/tracking/time`,
  getNewUsers: () => `${apiBaseUrl}/tracking/users`,
  getCourbes: () => `${apiBaseUrl}/tracking/visitOverTime`,
  getperiodUsers: () => `${apiBaseUrl}/tracking/periodUsers`,
  getdurationStats: () => `${apiBaseUrl}/tracking/durationStats`,
  getaverageVisitTimePerUser: () => `${apiBaseUrl}/tracking/averageVisitTimePerUser`,
  getOnlineVisitorForce: () => `${apiBaseUrl}/tracking/visit/onlineVisitorForce`,
  getdownloadsStats: () => `${apiBaseUrl}/downloads/count`,
  getInstallationsCount: () => `${apiBaseUrl}/installations/countPerDevice`,
  getUnifiedStats: () => `${apiBaseUrl}/tracking/unified`,
  getAgentUnifiedStats: () => `${apiBaseUrl}/tracking/agent/unified`,
  getVisitLast24: () => `${apiBaseUrl}/tracking/visit-last-24`,
  getResourceClickStats: () => `${apiBaseUrl}/tracking/resource-clicks`,

  getVisitsAgents: () => `${apiBaseUrl}/tracking/agent`,
  getTimeAgents: () => `${apiBaseUrl}/tracking/agent/time`,
  getNewUsersAgents: () => `${apiBaseUrl}/tracking/agent/users`,
  getCourbesAgents: () => `${apiBaseUrl}/tracking/agent/visitOverTime`,
  getperiodUsersAgents: () => `${apiBaseUrl}/tracking/agent/periodUsers`,
  getdurationStatsAgents: () => `${apiBaseUrl}/tracking/agent/durationStats`,
  getaverageTimeAgents: () => `${apiBaseUrl}/tracking/agent/averageTime`,

  // Promotion Links
  listPromotion: () => `${apiBaseUrl}/promotion-links/list`,
  deletePromotion: () => `${apiBaseUrl}/promotion-links/delete`,
  updatePromotion: () => `${apiBaseUrl}/promotion-links/update`,
  createPromotion: () => `${apiBaseUrl}/promotion-links/create`,
  detailPromotion: () => `${apiBaseUrl}/promotion-links/detail`,
  createDomainePromotion: () => `${apiBaseUrl}/promotion-links/create-with-domain`,
  userlinkPromotion: () => `${apiBaseUrl}/promotion-links/user-link`,
  enablePromotion: (id: number) => `${apiBaseUrl}/promotion-links/${id}/toggle-enable`,
  generateQrPromotion: () => `${apiBaseUrl}/promotion-links/generate-qr`,

  // Promotion-platform
  listPromotionPlatform: () => `${apiBaseUrl}/promotion-platform/list`,
  deletePromotionPlatform: () => `${apiBaseUrl}/promotion-platform/delete`,
  updatePromotionPlatform: () => `${apiBaseUrl}/promotion-platform/update`,
  createPromotionPlatform: () => `${apiBaseUrl}/promotion-platform/create`,

  // Promotion tracking
  listPromotionTrackingPlatforms: () => `${apiBaseUrl}/promotion-tracking/platforms/list`,
  listPromotionTrackingBindings: () => `${apiBaseUrl}/promotion-tracking/bindings/list`,
  createPromotionTrackingBinding: () => `${apiBaseUrl}/promotion-tracking/bindings/create`,
  updatePromotionTrackingBinding: () => `${apiBaseUrl}/promotion-tracking/bindings/update`,
  deletePromotionTrackingBinding: () => `${apiBaseUrl}/promotion-tracking/bindings/delete`,
  togglePromotionTrackingBinding: () => `${apiBaseUrl}/promotion-tracking/bindings/toggle`,
  listPromotionTrackingLogs: () => `${apiBaseUrl}/promotion-tracking/logs/list`,

  // CountryLanguages
  listCountry: () => `${apiBaseUrl}/country-language-config/list`,
  createlanguageConfig: () => `${apiBaseUrl}/country-language-config/create`,
  detailDomain: () => `${apiBaseUrl}/admin/domains/detail`,
  updateLanguageConfig: (id: number) => `${apiBaseUrl}/country-language-config/${id}/update`,
  deleteLanguageConfig: (id: number) => `${apiBaseUrl}/country-language-config/${id}/delete`,

  // Domain Surveillance
  triggerDomainCheck: () => `${apiBaseUrl}/admin/domain-surveillance/trigger`,
  listSurveillanceLogs: () => `${apiBaseUrl}/admin/domain-surveillance/logs`,
  getRegionalStatus: () => `${apiBaseUrl}/admin/domain-surveillance/regional-status`,
  getSurveillanceStats: () => `${apiBaseUrl}/admin/domain-surveillance/stats`,
  getBrowserStatusByDomain: () => `${apiBaseUrl}/admin/domain-surveillance/browser-status-by-domain`,
  testBrowserCheck: () => `${apiBaseUrl}/admin/domain-surveillance/test-browser`,
  testRegional7c: () => `${apiBaseUrl}/admin/domain-surveillance/test-regional-7c`,
  testRegionalItdog: () => `${apiBaseUrl}/admin/domain-surveillance/test-regional-itdog`,

  // Browser Domain Status
  updateBrowserStatus: () => `${apiBaseUrl}/admin/browser-domain-status/update`,
  getBrowserStatus: () => `${apiBaseUrl}/admin/browser-domain-status/get-status`,
  getBrowserStatusesByDomain: () => `${apiBaseUrl}/admin/browser-domain-status/get-by-domain`,
  getBrowserStatusesByBrowser: () => `${apiBaseUrl}/admin/browser-domain-status/get-by-browser`,
  listBrowserStatuses: () => `${apiBaseUrl}/admin/browser-domain-status/list`,
  getBrowserHistory: () => `${apiBaseUrl}/admin/browser-domain-status/history`,
  getBrowserHistoryByDomain: () => `${apiBaseUrl}/admin/browser-domain-status/history-by-domain`,
  getBrowserHistoryByBrowser: () => `${apiBaseUrl}/admin/browser-domain-status/history-by-browser`,
  listBrowserHistory: () => `${apiBaseUrl}/admin/browser-domain-status/list-history`,

  // Domain Short Mapping
  createDomainMapping: () => `${apiBaseUrl}/admin/domain-short-mapping/create`,
  listDomainMappings: () => `${apiBaseUrl}/admin/domain-short-mapping/list`,
  deleteDomainMapping: () => `${apiBaseUrl}/admin/domain-short-mapping/delete`,

  // API Failover Logs
  createFailoverLog: () => `${apiBaseUrl}/admin/api-failover-logs/create`,
  listFailoverLogs: () => `${apiBaseUrl}/admin/api-failover-logs/list`,
  testFailover: () => `${apiBaseUrl}/admin/api-failover-logs/test-failover`,

  // URLs JSON Management
  updateUrlsJson: () => `${apiBaseUrl}/admin/urls-json/update`,
  getCurrentUrlsJson: () => `${apiBaseUrl}/admin/urls-json/current`,
  previewUrlsJson: () => `${apiBaseUrl}/admin/urls-json/preview`,

  // Domain Change Logs (API Domains)
  listApiDomainChangeLogs: () => `${apiBaseUrl}/admin/domain-change-logs/api/list`,
  getApiDomainChangeLogDetail: () => `${apiBaseUrl}/admin/domain-change-logs/api/detail`,
  generateApiJson: () => `${apiBaseUrl}/admin/domain-change-logs/api/generate`,
  getCurrentApiJson: () => `${apiBaseUrl}/admin/domain-change-logs/api/current-json`,

  // Domain Change Logs (Resource Domains)
  listResourceDomainChangeLogs: () => `${apiBaseUrl}/admin/domain-change-logs/resource/list`,
  getResourceDomainChangeLogDetail: () => `${apiBaseUrl}/admin/domain-change-logs/resource/detail`,
  generateResourceJson: () => `${apiBaseUrl}/admin/domain-change-logs/resource/generate`,
  getCurrentResourceJson: () => `${apiBaseUrl}/admin/domain-change-logs/resource/current-json`,

  // Landing page requests
  createLandingPageRequest: () => `${apiBaseUrl}/landing-page-requests/create`,
  updateLandingPageRequest: () => `${apiBaseUrl}/landing-page-requests/update`,
  deleteLandingPageRequest: () => `${apiBaseUrl}/landing-page-requests/delete`,
  listLandingPageRequests: () => `${apiBaseUrl}/landing-page-requests/list`,
  listAllLandingPageRequests: () => `${apiBaseUrl}/landing-page-requests/list-all`,
  getLandingPageRequestById: () => `${apiBaseUrl}/landing-page-requests/get-by-id`,
  getLandingPageRequestsByAdmin: () => `${apiBaseUrl}/landing-page-requests/get-by-admin`,
  getLandingPageRequestsByAdminPaginated: () => `${apiBaseUrl}/landing-page-requests/get-by-admin-paginated`,
  updateLandingPageRequestStatus: () => `${apiBaseUrl}/landing-page-requests/update-status`,
  linkLandingPageToPromotion: () => `${apiBaseUrl}/landing-page-requests/link-promotion`,
  getLandingPageRequestsByStatus: () => `${apiBaseUrl}/landing-page-requests/get-by-status`,

  // Landing page templates
  getTemplates: () => `${apiBaseUrl}/landing-page-templates`,
  getTemplateById: (id: number) => `${apiBaseUrl}/landing-page-templates/${id}`,
  createTemplate: () => `${apiBaseUrl}/landing-page-templates/create`,
  updateTemplate: (id: number) => `${apiBaseUrl}/landing-page-templates/${id}/update`,
  deleteTemplate: (id: number) => `${apiBaseUrl}/landing-page-templates/${id}/delete`,

  // VIP Plans
  createVip: () => `${apiBaseUrl}/vip`,
  createVipByAgent: () => `${apiBaseUrl}/vip/create/by-agent`,
  listVips: () => `${apiBaseUrl}/vip/findAll`,
  listVipsCreatedByAdmin: () => `${apiBaseUrl}/vip/findAllCreatedByAdmin`,
  getVip: () => `${apiBaseUrl}/vip/findOne`,
  updateVip: (id: number) => `${apiBaseUrl}/vip/${id}/update`,
  deleteVip: (id: number) => `${apiBaseUrl}/vip/${id}/delete`,
  hardDeleteVip: (id: number) => `${apiBaseUrl}/vip/${id}/hard-delete`,
  addVipTranslation: (id: number, lang: string) => `${apiBaseUrl}/vip/${id}/translations/${lang}`,
  updateVipTranslation: (id: number, lang: string) => `${apiBaseUrl}/vip/${id}/translations/${lang}/update`,
  deleteVipTranslation: (id: number, lang: string) => `${apiBaseUrl}/vip/${id}/translations/${lang}/delete`,

  // VIP Rights
  createVipRight: () => `${apiBaseUrl}/vip-right`,
  listVipRights: () => `${apiBaseUrl}/vip-right/findAll`,
  getVipRight: () => `${apiBaseUrl}/vip-right/findOne`,
  updateVipRight: (id: number) => `${apiBaseUrl}/vip-right/${id}`,
  deleteVipRight: (id: number) => `${apiBaseUrl}/vip-right/${id}/delete`,
  addVipRightTranslation: (id: number, lang: string) => `${apiBaseUrl}/vip-right/${id}/translations/${lang}`,
  updateVipRightTranslation: (id: number, lang: string) => `${apiBaseUrl}/vip-right/${id}/translations/${lang}/update`,
  deleteVipRightTranslation: (id: number, lang: string) => `${apiBaseUrl}/vip-right/${id}/translations/${lang}/delete`,

  // VIP-Right Links
  attachVipRight: () => `${apiBaseUrl}/vip-right-link/attach`,
  detachVipRight: (vipId: number, rightId: number) => `${apiBaseUrl}/vip-right-link/${vipId}/${rightId}/detach`,
  toggleVipRight: (vipId: number, rightId: number) => `${apiBaseUrl}/vip-right-link/${vipId}/${rightId}/toggle`,
  updateVipRightEnabled: (vipId: number, rightId: number) => `${apiBaseUrl}/vip-right-link/${vipId}/${rightId}/enabled`,
  getRightsByVip: (vipId: number) => `${apiBaseUrl}/vip-right-link/by-vip/${vipId}`,
  getVipsByRight: (rightId: number) => `${apiBaseUrl}/vip-right-link/by-right/${rightId}`,

  // Payment Stats
  paymentStats: () => `${apiBaseUrl}/payment-orders/getPurchaseStats`,
  getUserBoughtVisitLast24: () => `${apiBaseUrl}/user-bought/visit-last-24`,

  // Notifications
  getNotifications: () => `${apiBaseUrl}/agent/notifications/stats`,
  markNotificationAsRead: (id: number) => `${apiBaseUrl}/agent/notifications/mark-as-read/${id}`,
  markAllNotificationsAsRead: () => `${apiBaseUrl}/agent/notifications/mark-all-as-read`,
  markNotificationAsConfirmed: (id: number) => `${apiBaseUrl}/agent/notifications/mark-as-confirmed/${id}`,

  // ADS - Core Advertisement Management
  createAd: () => `${apiBaseUrl}/ads`,
  listAds: () => `${apiBaseUrl}/ads/getAll`,
  listActiveAds: () => `${apiBaseUrl}/ads/active`,
  searchAdsAdvanced: () => `${apiBaseUrl}/ads/search/advanced`,
  getAdById: () => `${apiBaseUrl}/ads/getById`,
  updateAd: () => `${apiBaseUrl}/ads/update`,
  deleteAd: () => `${apiBaseUrl}/ads/delete`,
  selectAdPlacements: () => `${apiBaseUrl}/ads/select`,
  configAdPlacement: () => `${apiBaseUrl}/ads/config`,
  toggleAdPlacement: () => `${apiBaseUrl}/ads/toggle`,
  changeAdStatus: () => `${apiBaseUrl}/ads/status`,
  updateAdSchedule: () => `${apiBaseUrl}/ads/schedule`,
  uploadAdMedia: () => `${apiBaseUrl}/ads/resources/upload-all`,
  uploadAdVideoHLS: () => `${apiBaseUrl}/ads/resources/upload-video-hls`,

  // AD ACTIVITIES - Campaign Management
  createAdActivity: () => `${apiBaseUrl}/ad-activities`,
  listAdActivities: () => `${apiBaseUrl}/ad-activities/getAll`,
  listActiveAdActivities: () => `${apiBaseUrl}/ad-activities/active`,
  searchAdActivitiesAdvanced: () => `${apiBaseUrl}/ad-activities/search/advanced`,
  getAdActivityById: () => `${apiBaseUrl}/ad-activities/getById`,
  updateAdActivity: () => `${apiBaseUrl}/ad-activities/update`,
  deleteAdActivity: () => `${apiBaseUrl}/ad-activities/delete`,
  changeAdActivityStatus: () => `${apiBaseUrl}/ad-activities/status`,

  // AD COLLECTIONS - Ad Groups
  createAdCollection: () => `${apiBaseUrl}/ad-collections`,
  listAdCollections: () => `${apiBaseUrl}/ad-collections/getAll`,
  listActiveAdCollections: () => `${apiBaseUrl}/ad-collections/active`,
  getAdCollectionById: () => `${apiBaseUrl}/ad-collections/getById`,
  updateAdCollection: () => `${apiBaseUrl}/ad-collections/update`,
  deleteAdCollection: () => `${apiBaseUrl}/ad-collections/delete`,
  addAdsToCollection: () => `${apiBaseUrl}/ad-collections/add-ads`,
  removeAdFromCollection: () => `${apiBaseUrl}/ad-collections/remove-ad`,
  setCollectionDisplayMode: () => `${apiBaseUrl}/ad-collections/set-mode`,
  changeAdCollectionStatus: () => `${apiBaseUrl}/ad-collections/status`,

  // AD PLACEMENTS - Ad Positions
  createAdPlacement: () => `${apiBaseUrl}/ad-placements`,
  listAdPlacements: () => `${apiBaseUrl}/ad-placements/getAll`,
  listActiveAdPlacements: () => `${apiBaseUrl}/ad-placements/active`,
  searchAdPlacementsAdvanced: () => `${apiBaseUrl}/ad-placements/search/advanced`,
  getAdPlacementById: () => `${apiBaseUrl}/ad-placements/getById`,
  updateAdPlacement: () => `${apiBaseUrl}/ad-placements/update`,
  togglePlatform: () => `${apiBaseUrl}/ad-placements/toggle-platform`,
  deleteAdPlacement: () => `${apiBaseUrl}/ad-placements/delete`,
  setPlacementFrequency: () => `${apiBaseUrl}/ad-placements/set-frequency`,
  togglePlacementPlatform: () => `${apiBaseUrl}/ad-placements/toggle-platform`,
  setPlacementAllowedTypes: () => `${apiBaseUrl}/ad-placements/set-allowed-types`,

  // AD TRACKING - Click Tracking
  recordAdClick: () => `${apiBaseUrl}/ad-clicks`,
  listAdClicks: () => `${apiBaseUrl}/ad-clicks/getAll`,
  getAdClicksByAd: () => `${apiBaseUrl}/ad-clicks/getByAd`,
  getAdClicksByUser: () => `${apiBaseUrl}/ad-clicks/getByUser`,

  // AD TRACKING - Impression Tracking
  recordAdImpression: () => `${apiBaseUrl}/ad-impressions`,
  listAdImpressions: () => `${apiBaseUrl}/ad-impressions/getAll`,
  getAdImpressionsByAd: () => `${apiBaseUrl}/ad-impressions/getByAd`,

  // AD TRACKING - Conversion Tracking
  recordAdConversion: () => `${apiBaseUrl}/ad-conversions`,
  listAdConversions: () => `${apiBaseUrl}/ad-conversions/getAll`,
  getAdConversionsByAd: () => `${apiBaseUrl}/ad-conversions/getByAd`,

  // AD TRACKING - Video Play Tracking
  recordAdVideoPlay: () => `${apiBaseUrl}/ad-video-plays`,
  listAdVideoPlays: () => `${apiBaseUrl}/ad/watch/getAll`,

  // VIDEO ADS (NEW SYSTEM)
  listVideoAds: () => `${apiBaseUrl}/ad/video/find-all`,
  listVideoDurations: () => `${apiBaseUrl}/ad/duration-config/find-all`,
  listVideoWatchLogs: () => `${apiBaseUrl}/ad/watch/getAll`,
  uploadVideoAd: () => `${apiBaseUrl}/ad/video/upload`,
  uploadVideoAdHLS: () => `${apiBaseUrl}/ad/video/upload-hls`,
  uploadCoverImage: () => `${apiBaseUrl}/ad/video/upload-cover`,
  getVideoAdList: () => `${apiBaseUrl}/ad/video/list`,
  getVideoAdById: () => `${apiBaseUrl}/ad/video/find-one`,
  getVideoAdByDuration: () => `${apiBaseUrl}/ad/video/by-duration`,
  updateVideoAd: () => `${apiBaseUrl}/ad/video/update`,
  removeVideoAd: () => `${apiBaseUrl}/ad/video/remove`,

  // AD TARGETING - Country Targeting
  addAdCountryTarget: () => `${apiBaseUrl}/ad-countries`,
  bulkAddAdCountryTargets: () => `${apiBaseUrl}/ad-countries/bulk`,
  getAdCountriesByAd: () => `${apiBaseUrl}/ad-countries/getByAd`,
  getAdsByCountry: () => `${apiBaseUrl}/ad-countries/getByCountry`,
  deleteAdCountryTarget: () => `${apiBaseUrl}/ad-countries/delete`,

  // AD TARGETING - Device Targeting
  addAdDeviceType: () => `${apiBaseUrl}/ad-device-types`,
  bulkAddAdDeviceTypes: () => `${apiBaseUrl}/ad-device-types/bulk`,
  getAdDeviceTypesByAd: () => `${apiBaseUrl}/ad-device-types/getByAd`,

  // AD TARGETING - Platform Targeting
  addAdPlatformType: () => `${apiBaseUrl}/ad-platform-types`,
  getAdPlatformTypesByAd: () => `${apiBaseUrl}/ad-platform-types/getByAd`,
  bulkAddAdPlatformTypes: () => `${apiBaseUrl}/ad-platform-types/bulk`,

  // AD AGENTS - Publisher Management
  createAdAgent: () => `${apiBaseUrl}/ad-agents`,
  bulkCreateAdAgents: () => `${apiBaseUrl}/ad-agents/bulk`,
  getAdAgentsByAd: () => `${apiBaseUrl}/ad-agents/getByAd`,
  getAdsByAgent: () => `${apiBaseUrl}/ad-agents/getByAgent`,
  deleteAdAgent: () => `${apiBaseUrl}/ad-agents/delete`,
  clearAdAgentsByAd: () => `${apiBaseUrl}/ad-agents/clearByAd`,

  // BEHAVIOR TRIGGERS - Trigger Rules
  createBehaviorTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules`,
  listBehaviorTriggerRules: () => `${apiBaseUrl}/behavior-trigger-rules/getAll`,
  listActiveBehaviorTriggerRules: () => `${apiBaseUrl}/behavior-trigger-rules/active`,
  searchBehaviorTriggerRulesAdvanced: () => `${apiBaseUrl}/behavior-trigger-rules/search/advanced`,
  getBehaviorTriggerRuleById: () => `${apiBaseUrl}/behavior-trigger-rules/getById`,
  updateBehaviorTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules/update`,
  deleteBehaviorTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules/delete`,
  testBehaviorTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules/test`,
  validateBehaviorTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules/validate`,

  // BEHAVIOR TRIGGERS - Trigger Relations
  createAdTriggerRelation: () => `${apiBaseUrl}/ad-trigger-relations`,
  bulkCreateAdTriggerRelations: () => `${apiBaseUrl}/ad-trigger-relations/bulk`,
  toggleAdTrigger: () => `${apiBaseUrl}/ad-trigger-relations/toggle`,
  getAdTriggersByAd: () => `${apiBaseUrl}/ad-trigger-relations/getByAd`,

  // BEHAVIOR TRIGGERS - Trigger History
  recordAdTriggerHistory: () => `${apiBaseUrl}/ad-trigger-history`,
  getAdTriggerHistoryByUser: () => `${apiBaseUrl}/ad-trigger-history/find-by-user`,
  getAllAdTriggerHistory: () => `${apiBaseUrl}/ad-trigger-history/find-all`,
  getAdTriggerHistoryByTriggerRule: () => `${apiBaseUrl}/ad-trigger-history/find-by-trigger-rule`,

  // AD PLACEMENT RELATIONS
  createAdPlacementRelation: () => `${apiBaseUrl}/ad-placement-relations`,
  bulkCreateAdPlacementRelations: () => `${apiBaseUrl}/ad-placement-relations/bulk`,
  listAdPlacementRelations: () => `${apiBaseUrl}/ad-placement-relations/getAll`,
  getAdPlacementRelationsByAd: () => `${apiBaseUrl}/ad-placement-relations/getByAd`,
  getAdPlacementRelationsByPlacement: () => `${apiBaseUrl}/ad-placement-relations/getByPlacement`,

  // AD STATISTICS - Analytics Dashboard (Updated to use POST endpoints)
  getAdStatsOverview: () => `${apiBaseUrl}/ad-stats/overview`,
  getAdStatsByAd: () => `${apiBaseUrl}/ad-stats/by-ad`,
  getAdStatsByPlacement: () => `${apiBaseUrl}/ad-stats/by-placement`,
  getAdStatsByDateRange: () => `${apiBaseUrl}/ad-stats/by-date-range`,
  getTopPerformingAds: () => `${apiBaseUrl}/ad-stats/top-performing`,

  // Daily Success Stats
  getDailySuccessStats: () => `${apiBaseUrl}/payment-orders/daily-success-stats`,
  getMonthlySuccessStats: () => `${apiBaseUrl}/payment-orders/monthly-success-stats`,

  // AD GLOBAL SETTINGS - System Configuration (Updated to use POST endpoints)
  getAdGlobalSettings: () => `${apiBaseUrl}/ad-settings/global`,
  updateAdGlobalSettings: () => `${apiBaseUrl}/ad-settings/global/update`,
  toggleAdGlobalSettings: () => `${apiBaseUrl}/ad-settings/toggle-global`,
  toggleAdCategory: () => `${apiBaseUrl}/ad-settings/toggle-category`,
  toggleCategorySwitch: () => `${apiBaseUrl}/ad-settings/toggle-category-switch`,
  togglePlacementSwitch: () => `${apiBaseUrl}/ad-settings/toggle-placement-switch`,

  // SWITCH CONTROLS - Hierarchical Switch Management (Updated to use POST endpoints)
  getCategorySwitches: () => `${apiBaseUrl}/ad-switch-controls/categories`,
  getPlacementSwitches: () => `${apiBaseUrl}/ad-switch-controls/placements`,
  updateCategorySwitch: () => `${apiBaseUrl}/ad-switch-controls/category/update`,
  updatePlacementSwitch: () => `${apiBaseUrl}/ad-switch-controls/placement/update`,
  bulkTogglePlacements: () => `${apiBaseUrl}/ad-switch-controls/placements/bulk-toggle`,

  // AD ACTIVITIES - Enhanced with Ad Relations
  linkActivityOpenScreenAd: () => `${apiBaseUrl}/ad-activities/link-open-screen`,
  linkActivityPopupAd: () => `${apiBaseUrl}/ad-activities/link-popup`,
  unlinkActivityOpenScreenAd: () => `${apiBaseUrl}/ad-activities/unlink-open-screen`,
  unlinkActivityPopupAd: () => `${apiBaseUrl}/ad-activities/unlink-popup`,
  getActivityDisplayOrder: () => `${apiBaseUrl}/ad-activities/display-order`,

  // AD COLLECTIONS - Enhanced with Grid/Sequence Config
  updateCollectionGridConfig: () => `${apiBaseUrl}/ad-collections/grid-config`,
  updateCollectionSequenceConfig: () => `${apiBaseUrl}/ad-collections/sequence-config`,

  // BEHAVIOR TRIGGERS - Enhanced with Combined Rules
  createCombinedTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules/combined`,
  updateCombinedTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules/combined/update`,
  validateCombinedTriggerLogic: () => `${apiBaseUrl}/behavior-trigger-rules/combined/validate`,
  toggleTriggerRule: () => `${apiBaseUrl}/behavior-trigger-rules/toggle`,

  // AD PLACEMENTS - Enhanced with Platform Controls
  updatePlacementPlatformControls: () => `${apiBaseUrl}/ad-placements/platform-controls`,
  setPlacementAllowedFormats: () => `${apiBaseUrl}/ad-placements/allowed-formats`,
  setPlacementDisplayConfig: () => `${apiBaseUrl}/ad-placements/display-config`,
  togglePlacementStatus: () => `${apiBaseUrl}/ad-placements/update`,

  // AD PLACEMENTS - Batch Operations
  batchUpdatePlacementStatus: () => `${apiBaseUrl}/ad-placements/batch/update-status`,
  batchDeletePlacements: () => `${apiBaseUrl}/ad-placements/batch/delete`,
  batchSetPlacementFrequency: () => `${apiBaseUrl}/ad-placements/batch/set-frequency`,

  // AD GLOBAL SETTINGS - Global and Category Controls
  getAdSettings: () => `${apiBaseUrl}/ad-settings/global`,
  toggleGlobalAds: () => `${apiBaseUrl}/ad-settings/toggle-global`,
  toggleCategoryAds: () => `${apiBaseUrl}/ad-settings/toggle-category`,
  updateAdSettings: () => `${apiBaseUrl}/ad-settings/global/update`,

  // AD VIDEO PLAYS LOGS (Updated to use POST endpoints)
  getAdVideoById: () => `${apiBaseUrl}/ad/video/find-one`,
  listAdVideos: () => `${apiBaseUrl}/ad/video/find-all`,
  createAdVideo: () => `${apiBaseUrl}/ad/video`,
  updateAdVideo: () => `${apiBaseUrl}/ad/video/update`,
  deleteAdVideo: () => `${apiBaseUrl}/ad/video/remove`,
  getVideoDurationConfigs: () => `${apiBaseUrl}/ad/duration-config/find-all`,
  getActiveDurationConfig: () => `${apiBaseUrl}/ad/duration-config/active`,
  getVideoDurationConfig: () => `${apiBaseUrl}/ad/duration-config/find-one`,
  createVideoDurationConfig: () => `${apiBaseUrl}/ad/duration-config`,
  updateVideoDurationConfig: () => `${apiBaseUrl}/ad/duration-config/update`,
  deleteVideoDurationConfig: () => `${apiBaseUrl}/ad/duration-config/remove`,

  // Admin Income
  adminIncomeFindAll: () => `${apiBaseUrl}/admin-income/findAll`,

  // Exchangeable endpoints
  createExchange: () => `${apiBaseUrl}/exchange-rates`,
  listExchanges: () => `${apiBaseUrl}/exchange-rates/all`,
  getExchange: () => `${apiBaseUrl}/exchange-rates/get`,
  updateExchange: () => `${apiBaseUrl}/exchange-rates/update`,
  deleteExchange: () => `${apiBaseUrl}/exchange-rates/delete`,

  // Payment platform
  createPaymentPlatform: () => `${apiBaseUrl}/payment/platform/create`,
  listPaymentPlatforms: () => `${apiBaseUrl}/payment/platforms/all`,
  detailsPaymentPlatform: (id: number) => `${apiBaseUrl}/payment/platforms/${id}`,
  updatePaymentPlatform: (id: number) => `${apiBaseUrl}/payment/platforms/${id}/update`,
  deletePaymentPlatform: (id: number) => `${apiBaseUrl}/payment/platforms/${id}/delete`,
  // Payment channel
  createPayementChannel: () => `${apiBaseUrl}/payment/channels/create`,
  listPaymentChannels: () => `${apiBaseUrl}/payment/channels/all`,
  detailsPaymentChannel: (id: number) => `${apiBaseUrl}/payment/channels/${id}`,
  updatePaymentChannel: (id: number) => `${apiBaseUrl}/payment/channels/${id}/update`,
  deletePaymentChannel: (id: number) => `${apiBaseUrl}/payment/channels/${id}/delete`,
  getChannelStat: (id: number) => `${apiBaseUrl}/payment/channels/${id}/stat`,
  filterPaymentChannels: () => `${apiBaseUrl}/payment/channels/filter`,
  searchPayementChannels: () => `${apiBaseUrl}/payment/orders/search`,
  detailsCommande: (id: number) => `${apiBaseUrl}/payment/orders/${id}`,
  findAllPaymentOrders: () => `${apiBaseUrl}/payment-orders/findAll`,
  getAgentSalesRanking: () => `${apiBaseUrl}/payment-orders/agent-sales-ranking`,
  /** POST body: PaymentOrderIdDto { id } — lock_order = 1 */
  lockPaymentOrder: () => `${apiBaseUrl}/payment-orders/orders/lock`,
  /** POST body: PaymentOrderIdDto { id } — is_stolen = 0 等 */
  cancelStealPaymentOrder: () => `${apiBaseUrl}/payment-orders/orders/cancel_steal`,
  listLogs: () => `${apiBaseUrl}/payment/callback-logs/all`,
  paySelect: () => `${apiBaseUrl}/payment/channels/all/select`,
  detailLog: (id: number) => `${apiBaseUrl}/payment/callback-logs/${id}`,
  platformandChannel: (id: number) => `${apiBaseUrl}/payment/channels/platform/${id}`,
  // MANGAS
  // Mangas episode
  createMangaEpisode: () => `${apiBaseUrl}/mangas-episode/create`,
  listMangaEpisodes: () => `${apiBaseUrl}/mangas-episode/find-all`,
  getMangaEpisode: () => `${apiBaseUrl}/mangas-episode/find-one`,
  updateMangaEpisode: () => `${apiBaseUrl}/mangas-episode/update`,
  deleteMangaEpisode: () => `${apiBaseUrl}/mangas-episode/delete`,
  // Mangas Title
  createMangaTitle: () => `${apiBaseUrl}/mangas-title/create`,
  TitleList: () => `${apiBaseUrl}/mangas-title/list`,
  getMangaTitleDetail: () => `${apiBaseUrl}/mangas-title/detail`,
  updateMangaTitle: () => `${apiBaseUrl}/mangas-title/update`,
  deleteMangaTitle: () => `${apiBaseUrl}/mangas-title/delete`,
  // Mangas chapter
  createMangaChapter: () => `${apiBaseUrl}/mangas-chapter/create`,
  listMangaChapters: () => `${apiBaseUrl}/mangas-chapter/find-all`,
  getMangaChapter: () => `${apiBaseUrl}/mangas-chapter/find-one`,
  updateMangaChapter: () => `${apiBaseUrl}/mangas-chapter/update`,
  deleteMangaChapter: () => `${apiBaseUrl}/mangas-chapter/delete`,
  // MangesTagCategory
  createMangaTagCategory: () => `${apiBaseUrl}/mangas-tag-categories/create`,
  listMangaTagCategories: () => `${apiBaseUrl}/mangas-tag-categories/findAll`,
  getMangaTagCategory: () => `${apiBaseUrl}/mangas-tag-categories/findOne`,
  updateMangaTagCategory: () => `${apiBaseUrl}/mangas-tag-categories/update`,
  deleteMangaTagCategory: () => `${apiBaseUrl}/mangas-tag-categories/remove`,
  // Manges SubCategory
  createMangaSubCategory: () => `${apiBaseUrl}/mangas-sub-category`,
  listMangaSubCategories: () => `${apiBaseUrl}/mangas-sub-category/all`,
  getMangaSubCategory: (id: number) => `${apiBaseUrl}/mangas-sub-category/${id}`,
  updateMangaSubCategory: (id: number) => `${apiBaseUrl}/mangas-sub-category/${id}/update`,
  deleteMangaSubCategory: (id: number) => `${apiBaseUrl}/mangas-sub-category/${id}/delete`,
  // Mangas Category
  createMangaCategory: () => `${apiBaseUrl}/mangas-category`,
  listMangaCategories: () => `${apiBaseUrl}/mangas-category/all`,
  getMangaCategory: (id: number) => `${apiBaseUrl}/mangas-category/${id}`,
  updateMangaCategory: (id: number) => `${apiBaseUrl}/mangas-category/${id}/update`,
  deleteMangaCategory: (id: number) => `${apiBaseUrl}/mangas-category/${id}/delete`,
  // Mangas
  createManga: () => `${apiBaseUrl}/mangas/create`,
  listMangas: () => `${apiBaseUrl}/mangas/all`,
  getManga: () => `${apiBaseUrl}/mangas/detail`,
  updateManga: (id: number) => `${apiBaseUrl}/mangas/${id}/update`,
  deleteManga: (id: number) => `${apiBaseUrl}/mangas/${id}/delete`,
  // Mangas Images
  uploadMangaImagesEpisode: () => `${apiBaseUrl}/mangas-images`,
  listMangasImagesbyEpisode: () => `${apiBaseUrl}/mangas-images/by-episode`,
  updateMangasImages: () => `${apiBaseUrl}/mangas-images/update`,
  deleteMangasImages: () => `${apiBaseUrl}/mangas-images/delete`,
  // Mangas Tags
  createMangaTag: () => `${apiBaseUrl}/mangas-tags/create`,
  listMangaTags: () => `${apiBaseUrl}/mangas-tags/findAll`,
  getMangaTag: () => `${apiBaseUrl}/mangas-tags/findOne`,
  updateMangaTag: (id: number) => `${apiBaseUrl}/mangas-tags/${id}/update`,
  deleteMangaTag: (id: number) => `${apiBaseUrl}/mangas-tags/${id}/delete`,

  // Game Platforms
  createGamePlatform: () => `${apiBaseUrl}/game-platforms/create`,

  // Game Reduction
  listGameReductions: () => `${apiBaseUrl}/game-reduction/getAllGameReduce`,
  getGameReduce: () => `${apiBaseUrl}/game-reduction/getGameReduce`,
  getActiveGameReductions: () => `${apiBaseUrl}/game-reduction/getActiveGameReductions`,
  createUserGameReduce: () => `${apiBaseUrl}/game-reduction/createUserGameReduce`,
  createGameReduce: () => `${apiBaseUrl}/game-reduction/createGameReduce`,
  updateGameReduce: (id: number) => `${apiBaseUrl}/game-reduction/updateGameReduce/${id}`,
  deleteGameReduce: (id: number) => `${apiBaseUrl}/game-reduction/deleteGameReduce/${id}`,
  listGamePlatforms: () => `${apiBaseUrl}/game-platforms/find-all`,
  updateGamePlatform: (id: number) => `${apiBaseUrl}/game-platforms/update/${id}`,
  deleteGamePlatform: (id: number) => `${apiBaseUrl}/game-platforms/delete/${id}`,

  // Game Platform I18n (Country Mapping)
  createGamePlatformI18n: () => `${apiBaseUrl}/game-platform-i18n/create`,
  listGamePlatformI18n: () => `${apiBaseUrl}/game-platform-i18n/find-all`,
  updateGamePlatformI18n: (id: number) => `${apiBaseUrl}/game-platform-i18n/update/${id}`,
  deleteGamePlatformI18n: (id: number) => `${apiBaseUrl}/game-platform-i18n/delete/${id}`,

  // Games
  createGame: () => `${apiBaseUrl}/games/create`,
  listGames: () => `${apiBaseUrl}/games/find-all`,
  updateGame: (id: number) => `${apiBaseUrl}/games/update/${id}`,
  deleteGame: (id: number) => `${apiBaseUrl}/games/delete/${id}`,

  // Game I18n (Internationalization)
  createGameI18n: () => `${apiBaseUrl}/game-i18n/create`,
  listGameI18n: () => `${apiBaseUrl}/game-i18n/find-all`,

  // Agent Configs
  getNotifCN: () => `${apiBaseUrl}/agent-configs/getNotif`,
  setNotifCN: () => `${apiBaseUrl}/agent-configs/setNotif`,
  getAllKeys: () => `${apiBaseUrl}/agent-configs/getAllKeys`,
  getAllAgentConfigs: () => `${apiBaseUrl}/agent-configs/all`,
  getAgentConfigs: () => `${apiBaseUrl}/agent-configs/configs`,
  getStealConfig: () => `${apiBaseUrl}/agent-configs/getByAdminId`,
  /** POST — 返回 { code, msg, data: { global_steal, global_steal_robit } } */
  getGlobalSteal: () => `${apiBaseUrl}/agent-configs/getGlobalSteal`,
  /** POST body: { global_steal: 0|1, global_steal_robit: number } */
  setGlobalSteal: () => `${apiBaseUrl}/agent-configs/setGlobalSteal`,
  createAgentConfig: () => `${apiBaseUrl}/agent-configs/create`,
  createOrUpdateAgentConfig: () => `${apiBaseUrl}/agent-configs/createOrUpdate`,
  updateAgentConfigs: (id: number) => `${apiBaseUrl}/agent-configs/update/${id}`,
  deleteAgentConfig: (id: number) => `${apiBaseUrl}/agent-configs/delete/${id}`,
  /** GET ?key=… / POST body { key, value } — address 类 agent_configs */
  agentConfigAddressValue: () => `${apiBaseUrl}/agent-configs/address/agent_configs/value`,
  updateGameI18n: (id: number) => `${apiBaseUrl}/game-i18n/update/${id}`,
  deleteGameI18n: (id: number) => `${apiBaseUrl}/game-i18n/delete/${id}`,

  // CHAT
  listChatLogs: () => `${apiBaseUrl}/chat-logs/all`,

  // AD SETTINGS - Skip, Close Button, Breakpoints
  getAdSkipConfig: () => `${apiBaseUrl}/ad-settings/skip-config`,
  updateAdSkipConfig: () => `${apiBaseUrl}/ad-settings/skip-config/update`,
  getAdCloseButtonConfig: () => `${apiBaseUrl}/ad-settings/close-button/config`,
  updateAdCloseButtonConfig: () => `${apiBaseUrl}/ad-settings/close-button/update`,
  getAdResponsiveBreakpoints: () => `${apiBaseUrl}/ad-settings/responsive-breakpoints`,
  updateAdResponsiveBreakpoints: () => `${apiBaseUrl}/ad-settings/responsive-breakpoints/update`,

  // AD PLACEMENTS - Orientation and Close Button
  getAdPlacementsByOrientation: () => `${apiBaseUrl}/ad-placements/by-orientation`,
  updateAdPlacementOrientation: () => `${apiBaseUrl}/ad-placements/orientation/update`,
  getAdPlacementCloseButtonConfig: () => `${apiBaseUrl}/ad-placements/close-button/config`,
  updateAdPlacementCloseButton: () => `${apiBaseUrl}/ad-placements/close-button/update`,

  // Wallet Management
  listWallets: () => `${apiBaseUrl}/wallet/all`,
  // Endpoint pour récupérer les wallets liés à l'agent connecté
  listWalletsByAgent: () => `${apiBaseUrl}/wallet/allByAgent`,
  createWallet: () => `${apiBaseUrl}/wallet`,
  updateWallet: (id: number) => `${apiBaseUrl}/wallet/${id}/update`,
  chargeWallet: () => `${apiBaseUrl}/wallet/charge`,
  addFundsToWallet: (id: number) => `${apiBaseUrl}/wallet/${id}/add-funds`,
  getWalletDetails: (id: number) => `${apiBaseUrl}/wallet/${id}`,
  getWallet: (id: string) => `${apiBaseUrl}/wallet/${id}`,
  deleteWallet: (id: string) => `${apiBaseUrl}/wallet/${id}/delete`,
  closeWallet: (id: string) => `${apiBaseUrl}/wallet/${id}/close`,

  // Withdrawals Management
  createWithdrawal: () => `${apiBaseUrl}/withdrawals/create/my-withdrawal`,
  listWithdrawals: () => `${apiBaseUrl}/withdrawals/all`,
  listWithdrawalsByAgent: () => `${apiBaseUrl}/withdrawals/all-by-agent`,
  getWithdrawal: (id: string) => `${apiBaseUrl}/withdrawals/${id}`,
  updateWithdrawal: (id: string) => `${apiBaseUrl}/withdrawals/update/${id}`,
  updateMyWithdrawal: (id: string) => `${apiBaseUrl}/withdrawals/update/${id}`,
  markWithdrawalAsPaid: (id: string) => `${apiBaseUrl}/withdrawals/${id}/mark-paid`,
  payWithdrawal: (id: string) => `${apiBaseUrl}/withdrawals/pay/${id}`,
  deleteWithdrawal: (id: string) => `${apiBaseUrl}/withdrawals/${id}`,
  getWithdrawalStats: () => `${apiBaseUrl}/withdrawals/stats`,
  getMyWithdrawals: () => `${apiBaseUrl}/withdrawals/my-withdrawals`,
  initializeWithdrawalForm: () => `${apiBaseUrl}/withdrawals/start-withdrawals`,
  batchUpdatePlacementOrientation: () => `${apiBaseUrl}/ad-placements/batch/orientation`,
  batchUpdatePlacementCloseButton: () => `${apiBaseUrl}/ad-placements/batch/close-button`,

  // AD VIDEO - Skip Config and Orientation
  getAdVideoSkipConfig: () => `${apiBaseUrl}/ad/video/skip-config`,
  updateAdVideoSkipConfig: () => `${apiBaseUrl}/ad/video/skip-config/update`,
  getAdVideosByOrientation: () => `${apiBaseUrl}/ad/video/by-orientation`,
  updateAdVideoOrientation: () => `${apiBaseUrl}/ad/video/orientation/update`,
  batchUpdateAdVideoSkipConfig: () => `${apiBaseUrl}/ad/video/batch/skip-config`,
  batchUpdateAdVideoOrientation: () => `${apiBaseUrl}/ad/video/batch/orientation`,

  // DECRYPT
  decryptJSON: () => `${apiBaseUrl}/decrypt/json`,
  // DEVICES MANAGEMENT
  listDevices: () => `${apiBaseUrl}/downloads/devices`,

  // USERS
  listUsers: () => `${apiBaseUrl}/users/all`,
  listUsersWithVideos: () => `${apiBaseUrl}/users/with-videos`,
  searchUser: (query: string) => `${apiBaseUrl}/users/search/${query}`,
  updateUserPassword: (id: string) => `${apiBaseUrl}/users/update-password/${id}`,
  blockUsers:(id: string)=> `${apiBaseUrl}/users/update-status/${id}`,
  // Recherche d'utilisateurs - le backend filtrera selon le rôle de l'utilisateur
  // searchUserByAgent: (query: string) => `${apiBaseUrl}/users/searchByAgent/${query}`,

  // VIP USERS
  createUserVip: () => `${apiBaseUrl}/user-vips/create`,
  listUserVips: () => `${apiBaseUrl}/user-vips/findAll`,
  // Endpoint spécifique pour récupérer les user-vips pour un agent connecté
  listUserVipsByAgent: () => `${apiBaseUrl}/user-vips/findAllByAgent`,
  searchUserVips: () => `${apiBaseUrl}/user-vips/search`,
  getUserVips: () => `${apiBaseUrl}/vip/findAll`,
  getUserVip: () => `${apiBaseUrl}/agents/all`,
  updateUserVip: () => `${apiBaseUrl}/user-vips/update`,
  updateUserVipById: (id: string) => `${apiBaseUrl}/user-vips/${id}/update`,
  deleteUserVip: (id: string) => `${apiBaseUrl}/user-vips/${id}/delete`,
  toggleUserVip: (id: string) => `${apiBaseUrl}/user-vips/${id}/toggle`,
  toggleUserVipStatus: () => `${apiBaseUrl}/user-vips/toggle`,

  //PRICE
  createOrUpdatePrice: () => `${apiBaseUrl}/price-config/createOrUpdate`,
  deletePrice: () => `${apiBaseUrl}/price-config/delete`,
  getPriceConfig: () => `${apiBaseUrl}/price-config/getByAgentAndType`,
  listPriceConfig: () => `${apiBaseUrl}/price-config/list`,
  initializeAllAgents: () => `${apiBaseUrl}/price-config/initializeAllAgents`,

  // Steal Settings N-1
  listStealSettings: () => `${apiBaseUrl}/steal-setting/all`,
  getStealSetting: (id: string | number) => `${apiBaseUrl}/steal-setting/${id}`,
  saveStealSetting: () => `${apiBaseUrl}/steal-setting/save`,
}
